import DemoBadge from '@/components/feature/DemoBadge';

export default function PlacementShowcase() {
  return (
    <section className="bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Placements</p>
        <DemoBadge label="Previews" />
      </div>
      <h2 className="font-heading font-bold text-4xl md:text-6xl text-foreground-950 leading-[1.02]">See your brand in place</h2>
      <p className="mt-4 text-foreground-600 max-w-2xl">A quick look at how sponsorship shows up around the site. Every example below uses placeholder branding.</p>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Featured homepage sponsor */}
        <article className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          <div className="bg-foreground-950 px-5 py-4 flex items-center justify-between gap-3">
            <span className="font-label uppercase tracking-[0.22em] text-[10px] text-accent-400 font-bold">Featured sponsor</span>
            <span className="w-8 h-8 rounded-md bg-foreground-800 text-accent-400 flex items-center justify-center"><i className="ri-award-line"></i></span>
          </div>
          <div className="p-5">
            <p className="font-heading font-bold text-xl text-foreground-950">Fairway Financial Group</p>
            <p className="text-sm text-foreground-600 mt-1">Homepage sponsor strip — seen by every visitor, right below the cover story.</p>
          </div>
        </article>

        {/* Sponsored tournament */}
        <article className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          <div className="h-32 bg-primary-100 flex items-center justify-center text-primary-600 text-3xl">
            <i className="ri-trophy-line"></i>
          </div>
          <div className="p-5">
            <p className="font-label uppercase tracking-widest text-[10px] text-foreground-500">Presented by <span className="text-foreground-900 font-semibold">Coastal Mutual</span></p>
            <p className="font-heading font-bold text-xl text-foreground-950 mt-2">Sponsored tournament placement</p>
            <p className="text-sm text-foreground-600 mt-1">A dedicated homepage feature for a sponsored tournament, above the standard listing.</p>
          </div>
        </article>

        {/* Newsletter sponsorship */}
        <article className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          <div className="bg-primary-800 px-5 py-4">
            <p className="font-label uppercase tracking-[0.22em] text-[10px] text-accent-400 font-bold">Weekly Digest</p>
            <p className="font-heading font-bold text-background-50 text-lg mt-1">Presented by 19th Hole Brewing Co.</p>
          </div>
          <div className="p-5 space-y-2">
            <div className="h-3 rounded bg-background-200 w-full"></div>
            <div className="h-3 rounded bg-background-200 w-5/6"></div>
            <div className="h-3 rounded bg-background-200 w-2/3"></div>
            <p className="text-sm text-foreground-600 pt-2">One sponsor owns the top of each newsletter send — the highest-retention placement on the site.</p>
          </div>
        </article>
      </div>
    </section>
  );
}